<script>

import { api } from '@/modules/api'
import ShopList from "@/components/shop/ShopList.vue";
import ShopFilters from "@/components/shop/ShopFilters.vue";

export default {
  name: 'ShopView',
  components: {ShopFilters, ShopList},
  data () {
    return {
      products: {},
      viewModal: false,
      filters: {},
      search: ''
    }
  },
  async mounted () {
    await this.loadData()
    this.emitter.on('filter-shop', (event) => {
      this.filters = event
      this.loadData()
    })
    this.emitter.on('search', event => {
      this.search = event
      this.loadData()
    })
    this.emitter.on('load-data', () => {
      this.loadData()
    })
  },
  methods: {
    async loadData() {
      let url = '?'

      Object.keys(this.filters).forEach(key => {
        if (key === 'price') {
          url += `priceMin=${this.filters[key].min}&`
          url += `priceMax=${this.filters[key].max}&`
        } else {
          url += `${key}=${this.filters[key]}&`
        }
      })
      if (this.search !== '') {
        url += `search=${this.search}`
      }
      this.products = await api.products.get(url)
    }
  }
}
</script>

<template>
  <div class="flex flex-wrap flex-col md:flex-row gap-4">
    <shop-filters />
    <shop-list :products="products" :filters="filters" />
  </div>

</template>
